import { createSlice } from "@reduxjs/toolkit";
import { CROP_OFF, CROP_ON } from "../constants/variables";

const initialState = {
  zoom: 1,
  cropOn: false,
};

const slice = createSlice({
  name: "crop",
  initialState,
  reducers: {
    setZoom: (state, { payload }) => {
      state.zoom = payload;
    },
    setCropMode: (state, { payload }) => {
      state.cropOn = payload;
    },
  },
});

export const { setZoom, setCropMode } = slice.actions;

export const crop = slice.reducer;
